import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "../../../assets/svgs";
import VideoItem from "./VideoItem";

const List = ({
  searchShow,
  filteredVideos,
  currentVideo,
  handleVideoChange,
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleItemClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  return (
    <div className={searchShow ? "playlist" : "playlist-hidden"}>
      <div className="playlist-items">
        {filteredVideos?.map((video, index) => {
          const btnClass =
            currentVideo?.id === index
              ? "playlist-button active"
              : "playlist-button";
          return !video?.items ? (
            <VideoItem
              items={null}
              btnClass={btnClass}
              setter={handleVideoChange}
              index={index}
              video={video}
              key={index}
            />
          ) : (
            <div
              className={`accordion-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="ptest accordion-title"
                onClick={() => handleItemClick(index)}
              >
                {video.title}
                {activeIndex === index ? (
                  <FiChevronUp height="20px" width="20px" />
                ) : (
                  <FiChevronDown height="20px" width="20px" />
                )}
              </div>
              {activeIndex === index && (
                <div className="accordion-content">
                  {video?.items?.map((vid, idx) => {
                    const btnClass =
                      currentVideo?.id === idx
                        ? "playlist-button active"
                        : "playlist-button";
                    return (
                      <VideoItem
                        btnClass={btnClass}
                        setter={handleVideoChange}
                        items={video?.items}
                        index={idx}
                        video={vid}
                        key={idx}
                      />
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
